// src/js/config/ui/handleSelectConfigChangeUI.js

import { DOMElements } from '../dom.js';
import { toggleDeleteButtonVisibility } from './toggleDeleteButtonVisibility.js';

/**
 * Hanterar UI-uppdateringar när valet i konfigurationslistan ändras.
 * Aktiverar/inaktiverar knappar och anropar andra UI-funktioner.
 * @param {string} selectedValue - Det nya värdet från select-listan.
 */
export function handleSelectConfigChangeUI(selectedValue) {
    const { loadConfigBtn, deleteConfigBtn } = DOMElements;

    const isDisabled = (selectedValue === "default" || !selectedValue);

    if (loadConfigBtn) {
        loadConfigBtn.disabled = isDisabled;
    }
    if (deleteConfigBtn) {
        deleteConfigBtn.disabled = isDisabled;
    }

    // Anropa den specifika funktionen för att hantera synligheten
    toggleDeleteButtonVisibility(selectedValue);
}